import React, {ReactElement} from 'react';
import {cx} from '@emotion/css';

import Button from '@fo/components/DesignSystem/Buttons/Button/Button';
import {ButtonVariant} from '@fo/components/DesignSystem/Buttons/Button/types';
import DialogueCard from '@fo/components/DesignSystem/DialogueCard/DialogueCard';
import Headers, {HeaderType} from '@fo/components/DesignSystem/Text/Headers/Headers';
import Paragraph from '@fo/components/DesignSystem/Text/Paragraph/Paragraph';
import {fonts} from '@fo/shared/styles/variables';
import {RequireAtLeastOne} from '@fo/shared-types';

import styles from './CreateAccountTypeModal.styles';

type Props = RequireAtLeastOne<
  {
    name: string;
    title: string;
    description: string;
    buttonLabel: string;
    href?: string;
    onClick?: () => void;
    onClose?: () => void;
  },
  'onClick' | 'href'
>;

const AccountTypeCard = ({name, title, description, buttonLabel, href, onClose, onClick}: Props): ReactElement => (
  <DialogueCard isHideCloseButton name={name} className={cx(styles.card)}>
    <div className={cx(styles.cardContent)}>
      <Headers headerType={HeaderType.H4} alignment={fonts.alignment.CENTER}>
        {title}
      </Headers>
      <Paragraph className={cx(styles.cardCopy)} testId={`modal.createAccountType.${name}.description`}>
        {description}
      </Paragraph>
      <Button
        className={cx(styles.cardButton)}
        ariaLabel={buttonLabel}
        href={href}
        onClick={() => {
          if (onClose && !onClick) {
            onClose();
          }

          if (onClick) {
            onClick();
          }
        }}
        variant={ButtonVariant.CALL_TO_ACTION}
        testId={`modal.createAccountType.${name}.button`}
      >
        {buttonLabel}
      </Button>
    </div>
  </DialogueCard>
);

export default AccountTypeCard;
